import service from '@/utils/request'

// 查询供应商基本信息
export function supplierInfoFindName(param) {
	return service.request({
		method: 'POST',
		url: '/app/supplierInfo/supplierInfoFindName',
		data: param
	})
}

// 查询供应商基本信息
export function supplierInfoList(param) {
	return service.request({
		method: 'POST',
		url: '/app/supplierInfo/supplierInfoList',
		data: param
	})
}
// 查询供应商基本信息 不分页
export function supplierInfoListAll() {
	return service.request({
		method: 'POST',
		url: '/app/supplierInfo/list',
	})
}
// 新增供应商基本信息
export function addSupplierInfo(param) {
	return service.request({
		method: 'POST',
		url: '/app/supplierInfo/add',
		data: param
	})
}
// 修改供应商基本信息
export function editSupplierInfo(param) {
	return service.request({
		method: 'POST',
		url: '/app/supplierInfo/edit',
		data: param
	})
}

// 批量删除供应商基本信息
export function batchDelSupplierInfo(param) {
	return service.request({
		method: 'POST',
		url: '/app/supplierInfo/batchDel',
		data: param
	})
}



// 删除供应商基本信息
export function delSupplierInfo(param) {
	return service.request({
		method: 'POST',
		url: '/app/supplierInfo/del',
		data: param
	})
}
// 导出供应商基本信息
export function exportSupplierInfo(param) {
	return service.request({
		method: 'POST',
		url: '/app/supplierInfo/export',
		data: param
	})
}
// 根据ID查询信息
export function supplierInfoById(param) {
	return service.request({
		method: 'POST',
		url: '/app/supplierInfo/supplierInfoById',
		data: param
	})
}
// 根据ID查询信息
export function supplierApprovalRecordById(param) {
	return service.request({
		method: 'POST',
		url: '/app/supplierApprovalRecord/supplierApprovalRecordById',
		data: param
	})
}

// 供应商绑定 分类

export function gysAddClassSaveList(param) {
	return service.request({
		method: 'POST',
		url: '/app/supplierInfoBasicClassify/addSaveList',
		data: param
	})
}

// 获取 供应商绑定 分类 列表
export function supplierInfoBasicClassifyList(param) {
	return service.request({
		method: 'POST',
		url: '/app/supplierInfoBasicClassify/supplierInfoBasicClassifyList',
		data: param
	})
}


// 获取 供应商绑定 分类 列表
export function gysdelClassifyList(param) {
	return service.request({
		method: 'POST',
		url: '/app/supplierInfoBasicClassify/del',
		data: param
	})
}

// 获取 供应商信息
export function getByGysBasicId(param) {
	return service.request({
		method: 'POST',
		url: '/app/supplierOperLog/getByGysBasicId',
		data: param
	})
}

export function getAuditListByRecordId(param) {
	return service.request({
		method: 'POST',
		url: '/app/supplierOperLog/getByRecordId',
		data: param
	})
}



export function getDetailByRecordId(param) {
	return service.request({
		method: 'POST',
		url: '/app/supplierApprovalMx/getDetailByRecordId',
		data: param
	})
}


export function submitAuditBasicInfo(param) {
	return service.request({
		method: 'POST',
		url: '/app/supplierInfo/auditBasicInfo',
		data: param
	})
}

export function addSupplierApprovalMx(param) {
	return service.request({
		method: 'POST',
		url: '/app/supplierApprovalMx/add',
		data: param
	})
}

export function getSupplierApprovalMx(param) {
	return service.request({
		method: 'POST',
		url: '/app/supplierApprovalMx/getDetail',
		data: param
	})
}







